export default "__VITE_ASSET__1828bade__"